
export function makeCaptchaToken(key: string): Promise<string> {
    return new Promise<string>(
        (resolve) => {
            grecaptcha.ready(() => {
                // @ts-ignore
                window.grecaptcha
                    .execute(key, {action: 'submit'})
                    .then((token: string) => {
                        resolve(token);
                    })
            })
        }
    );
}

const grecaptcha = {
    ready: function(cb: Function){
        // @ts-ignore
        if(typeof window.grecaptcha === 'undefined') {
            const c = '___grecaptcha_cfg';
            // @ts-ignore
            window[c] = window[c] || {};
            // @ts-ignore
            (window[c]['fns'] = window[c]['fns']||[]).push(cb);
        } else {
            cb();
        }
    }
};
